import { Injectable } from "@angular/core";
import * as _ from 'lodash';
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../services/utils.service";
import { AuthService } from "../../services/auth.service";
import { IAgent } from "../../../admin/agents-page/agents/agents.interface";
import { IClient } from "../../../admin/clients-page/clients/clients.interface";
import { ITask } from "../../../admin/tasks-page/tasks/task.interface";
import { apiURL, EnvConfig, webappURL } from "../../../../env-config";

@Injectable()
export class ExternalRequestService {
  constructor(
    private _http: HttpService,
    private _UtilsService: UtilsService,
    private _AuthService: AuthService,
  ) { }

  async getTaskRequest(agent: IAgent | null): Promise<any> {
    const data: any = {
      type: 'TaskRequests',
      params: { agent: agent ? agent._id : null },
      company: this._AuthService.companyId()
    };
    return await this.createExternalRequest(data);
  }

  async getDeliveryNote(note: any): Promise<any> {
    let id = (typeof note == 'string') ? note : note._id;
    const data: any = {
      type: 'SingleDeliveryNote',
      params: { deliverynote: note._id, },
      company: this._AuthService.companyId()
    };
    return await this.createExternalRequest(data);
  }

  getSingleTask(task: ITask): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let id = (typeof task == 'string') ? task : task._id;
      const data: any = {
        type: 'SingleTask',
        params: { task: task._id, },
        company: this._AuthService.companyId()
      };
      resolve(await this.createExternalRequest(data));
    })
  }

  getTodayClientTasks(client: IClient): Promise<any> {
    const today: string = this._UtilsService.date.toLocale(new Date().toISOString()).substring(0, 10);
    const scheduledStart = this._UtilsService.date.toUTC(today + 'T00:00:00.000Z');
    const scheduledEnd = this._UtilsService.date.toUTC(today + 'T23:59:59.999Z');
    return this.getClientTasks(client, scheduledStart, scheduledEnd);
  }

  getClientTasks(client: IClient, scheduledStart: any, scheduledEnd: any): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let id = (typeof client == 'string') ? client : client._id;
      const data: any = {
        type: 'ClientTaskList', client: id,
        params: {
          scheduledStart: scheduledStart,
          scheduledEnd: scheduledEnd,
        },
        company: this._AuthService.companyId()
      };
      resolve(await this.createExternalRequest(data));
    })
  }

  getQuotePdf(task: ITask): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let id = (typeof task == 'string') ? task : task._id;
      const data: any = {
        type: 'PdfQuote',
        params: { task: task._id, },
        company: this._AuthService.companyId()
      };
      resolve(await this.createExternalRequest(data));
    })
  }

  openExternalRequest(id: string) {
    window.open(webappURL(`${id}`), '_blank');
  }

  getExternalRequestUrl(id: string) {
    return webappURL(`${id}`);
  }

  private createExternalRequest(data: any) {
    return new Promise((resolve, reject) => {
      data = this._UtilsService.removeNullOrEmpty(data);
      this._http.post(`${apiURL(EnvConfig.API_EXTERNAL)}/request`, data).subscribe(response => {
        resolve(response);
      });
    })
  }
}